import React, { useState } from 'react';
import login from '../../css/style.module.css';
import { toast } from 'react-toastify';

import img from '../../assest/logo.png';
import { postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import { useNavigate } from 'react-router-dom';

const ForgetPassword = () => {
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [otpResponse, setOtpResponse] = useState(null);
    const [showPassword, setShowPassword] = useState(false);


    const navigate = useNavigate();

    const handleSendOtp = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.error('Please enter your email');
            return;
        }

        setLoading(true);

        try {
            const response = await postApi(endPoints.sendOtp, { email }, {
                successMsg: '',
                errorMsg: 'Failed to send OTP!',
            });

            setOtpResponse(response);

            toast.success(`OTP sent to your email!`);
            setStep(2);
        } catch (error) {
            console.error('Send OTP error:', error);
            toast.error('Failed to send OTP!');
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();

        if (!otp || !newPassword || !confirmPassword) {
            toast.error('Please fill all fields');
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        setLoading(true);

        try {
            await postApi(endPoints.resetPassword(otpResponse?.data?._id), { otp, newPassword, confirmPassword }, {
                setResponse: () => {
                    toast.success('Password reset successfully!');
                    setStep(1);
                    setEmail('');
                    setOtp('');
                    setNewPassword('');
                    setConfirmPassword('');
                },
                successMsg: '',
                errorMsg: 'Failed to reset password!',
            });
            navigate('/')
        } catch (error) {
            console.error('Reset password error:', error);
            toast.error('Failed to reset password!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={login.logincontainer}>
            <div className={login.loginsubContainer}>
                <div className={login.loginlogo}>
                    <img src={img} alt="Logo" />
                </div>

                <div className={login.loginheading}>
                    <h3>Forget Password</h3>
                </div>

                <div className={login.loginbox}>
                    {step === 1 && (
                        <form onSubmit={handleSendOtp}>
                            <div className={login.logininputs}>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your registered email"
                                    className={login.logininputsemail}
                                />
                            </div>

                            <div className={login.button1} style={{ marginTop: '1rem', textAlign: "center" }}>
                                <button type="submit" disabled={loading}>
                                    {loading ? 'Sending OTP...' : 'Send OTP'}
                                </button>
                            </div>
                        </form>
                    )}

                    {step === 2 && (
                        <form onSubmit={handleResetPassword}>
                            <div className={login.logininputs}>
                                <input
                                    type="text"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    placeholder="Enter OTP"
                                    className={login.logininputsemail}
                                />

                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    placeholder="New Password"
                                    className={login.logininputsemail}
                                />

                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Confirm New Password"
                                    className={login.logininputsemail}
                                />
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}>
                                    <input
                                        type="checkbox"
                                        checked={showPassword}
                                        onChange={() => setShowPassword((prev) => !prev)}
                                    />
                                    Show Password
                                </div>
                            </div>

                            <div className={login.button1} style={{ marginTop: '1rem', textAlign: "center" }}>
                                <button type="submit" disabled={loading}>
                                    {loading ? 'Resetting Password...' : 'Reset Password'}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ForgetPassword;
